import { RainGaugeRainfall } from '@/model/RainGaugeRainfall'
import { StationEntity } from './StationEntity'

export class RainGauge implements StationEntity {
  constructor(
    readonly id: number,
    readonly name: string,
    readonly stationTypes: string[],
    readonly location: [number, number],
    readonly rainfall: RainGaugeRainfall,
  ) {}

  getLngLat(): [number, number] {
    return [this.location[1], this.location[0]]
  }
}
